import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface ProblemReportScreenshot {
  fileName: string;
  contentType: string;
  sizeBytes: number;
  contentBase64: string;
}

export interface ProblemReportRequest {
  description: string;
  currentUrl: string;
  browserInfo: string;
  screenResolution: string;
  applicationVersion: string;
  sectorId: number | null;
  routeId: number | null;
  routeDate: string | null;
  screenshot?: ProblemReportScreenshot;
}

export interface ProblemReportResponse {
  freshdeskTicketId: string | number;
  freshdeskTicketUrl?: string;
}

@Injectable({ providedIn: 'root' })
export class ProblemReportService {
  private readonly endpoint = environment.apiUrlV5 + 'api/tpsl-route/problem-reports';

  constructor(private http: HttpClient) {}

  submit(request: ProblemReportRequest): Observable<ProblemReportResponse> {
    return this.http.post<ProblemReportResponse>(this.endpoint, request);
  }
}
